'use strict';

const ENABLE_ASYNC = true;

class AjaxClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }

    post(payload, endpoint) {
        this.httpClient.open('POST', endpoint, ENABLE_ASYNC);
        this.httpClient.setRequestHeader('Content-type', 'application/json');
        this.httpClient.send(JSON.stringify(payload));
    }

    get(url) {
        return new Promise((resolve, reject) => {
            this.httpClient.open('GET', url, ENABLE_ASYNC);
            this.httpClient.onload = data => {
                if (data.currentTarget.status !== 200) {
                    return reject(data);
                } else {
                    return resolve(data);
                }
            };
            this.httpClient.onerror = reject;
            this.httpClient.send();
        });
    }
}

module.exports = AjaxClient;